import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const addUserFeatureSeen = (userFeatureData) => async (dispatch) => {
    try {
        const { data } = await api.addUserFeatureSeen(userFeatureData);

        dispatch({
            type: Actions.ADD_USER_FEATURE_SEEN,
            payload: data
        })
    }catch (error) {
        console.log(error);
    }
}
